import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQrcode } from '@fortawesome/free-solid-svg-icons'
import loadingImg from '../loading.svg'
import jwt_decode from 'jwt-decode'

import QrScanner from '../components/QrScanner'

import logo from '../img/logo-white.png'

import '../login.css'

const baseUrl = '/api'

// Estrae il token sia da URL completi (https://.../qr-login?token=...) che
// da QR che contengono il solo token plain.
function extractTokenFromScan(text) {
  if (!text) return ''
  const trimmed = String(text).trim()
  try {
    const url = new URL(trimmed)
    const fromQuery = url.searchParams.get('token')
    if (fromQuery) return fromQuery
  } catch (e) {
    /* non era un URL — trattalo come token grezzo */
  }
  return trimmed
}

// Il backend risponde sempre 204 (no enumeration). Mostriamo lo stesso
// messaggio di esito a prescindere dall'esistenza dell'email.
async function resetPassword(email) {
  try {
    await fetch(
      `${baseUrl}/users/reset-password/` + encodeURIComponent(email),
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      },
    )
    return { ok: true }
  } catch (e) {
    return { ok: false, error: 'Impossibile contattare il server. Riprova.' }
  }
}

function Login(props) {
  let [username, setUsername] = useState('')
  let [password, setPassword] = useState('')
  let [error, setError] = useState('')
  let [loading, setLoading] = useState(false)
  let [reset, setReset] = useState(false)
  let [resetSent, setResetSent] = useState(false)
  let [resetLoading, setResetLoading] = useState(false)
  let [scannerOpen, setScannerOpen] = useState(false)
  let [qrConsuming, setQrConsuming] = useState(false)
  const history = useHistory()

  const onQrScanned = async text => {
    const token = extractTokenFromScan(text)
    setScannerOpen(false)
    if (!token) {
      setError('QR non valido. Riprova.')
      setTimeout(() => setError(''), 3000)
      return
    }
    setQrConsuming(true)
    setError('')
    try {
      const r = await fetch(`${baseUrl}/auth/qr-login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token }),
      })
      if (!r.ok) {
        if (r.status === 401) {
          setError('QR non valido o già usato. Chiedi un nuovo QR all\'admin.')
        } else if (r.status === 429) {
          setError('Troppi tentativi. Riprova tra qualche istante.')
        } else {
          setError('Accesso fallito. Riprova.')
        }
        setTimeout(() => setError(''), 4000)
        return
      }
      const data = await r.json()
      if (data && data.token) {
        localStorage.setItem('cut-catering-token', data.token)
        props.setUser(jwt_decode(data.token))
        history.push('/order')
      }
    } catch (e) {
      setError('Impossibile contattare il server.')
      setTimeout(() => setError(''), 3000)
    } finally {
      setQrConsuming(false)
    }
  }

  const onResetSubmit = async () => {
    if (resetLoading) return
    if (!username || !username.includes('@')) {
      setError('Inserisci un indirizzo email valido.')
      setTimeout(() => setError(''), 3000)
      return
    }
    setResetLoading(true)
    setError('')
    const r = await resetPassword(username)
    setResetLoading(false)
    if (r.ok) {
      setResetSent(true)
    } else {
      setError(r.error)
      setTimeout(() => setError(''), 3000)
    }
  }

  if (reset)
    return (
      <>
        <div className="login-page">
          <div className="login-box">
            <div className="login-title-box">
              <img src={logo} className="logo-small" alt="logo app"></img>
            </div>

            <div className="login-input-box">
              <h1 className="login-title">Reimposta password</h1>
              {resetSent ? (
                <div className="reset-confirm">
                  <p style={{ margin: '12px 0', lineHeight: 1.5 }}>
                    Se l'email <b>{username}</b> è registrata, ti abbiamo
                    inviato un link per reimpostare la password.
                  </p>
                  <p style={{ margin: '12px 0', color: '#666', fontSize: 14 }}>
                    Il link è valido per 60 minuti. Controlla anche la cartella
                    spam.
                  </p>
                </div>
              ) : (
                <>
                  <div className="login-input-row login-name-row">
                    <input
                      className="login-input"
                      type="email"
                      id="nome"
                      name="nome"
                      placeholder="mail..."
                      value={username}
                      onKeyDown={e => {
                        if (e.code === 'Enter') onResetSubmit()
                      }}
                      onChange={event => setUsername(event.target.value)}
                    />
                  </div>

                  <div className="login-submit-row">
                    <button
                      className="login-button"
                      onClick={onResetSubmit}
                      type="submit"
                      disabled={resetLoading}
                    >
                      {resetLoading ? (
                        <img src={loadingImg} alt="loading..." />
                      ) : (
                        'Invia mail'
                      )}
                    </button>
                  </div>
                </>
              )}
            </div>
            {error ? (
              <div className="error-box">
                <div className="error-row">
                  <p>{error}</p>
                </div>
              </div>
            ) : null}
            <div
              className="restore-option"
              onClick={() => {
                setReset(false)
                setResetSent(false)
                setError('')
              }}
            >
              accedi normalmente
            </div>
          </div>
        </div>
      </>
    )
  return (
    <>
      <div className="login-page">
        <div className="login-box">
          <div className="login-title-box">
            {/* <h1 className="login-title">Admin Panel</h1> */}
            <img src={logo} className="logo-small" alt="logo app"></img>
          </div>
          <div className="login-input-box">
            <h1 className="login-title">Sei registrato?</h1>
            <div className="login-input-row login-name-row">
              <input
                className="login-input"
                type="text"
                id="nome"
                name="nome"
                placeholder="email..."
                onKeyDown={e => {
                  if (e.code === 'Enter') {
                    login(
                      username,
                      password,
                      setError,
                      setLoading,
                      setPassword,
                      props,
                    )
                  }
                }}
                value={username}
                onChange={event => setUsername(event.target.value)}
              />
            </div>
            <div className="login-input-row login-name-row">
              <input
                className="login-input"
                type="password"
                name="password"
                id="password"
                placeholder="password..."
                onKeyDown={e => {
                  if (e.code === 'Enter') {
                    login(
                      username,
                      password,
                      setError,
                      setLoading,
                      setPassword,
                      props,
                    )
                  }
                }}
                value={password}
                onChange={event => setPassword(event.target.value)}
              />
            </div>
            <div className="login-submit-row">
              <button
                className="login-button"
                onClick={() => {
                  login(
                    username,
                    password,
                    setError,
                    setLoading,
                    setPassword,
                    props,
                  )
                }}
                onKeyDown={e => {
                  if (e.code === 'Enter') {
                    login(
                      username,
                      password,
                      setError,
                      setLoading,
                      setPassword,
                      props,
                    )
                  }
                }}
                type="submit"
              >
                {loading ? <img src={loadingImg} alt="loading..." /> : 'Login'}
              </button>
            </div>
            <div className="login-qr-row">
              <button
                type="button"
                className="login-qr-button"
                onClick={() => setScannerOpen(true)}
                disabled={qrConsuming}
              >
                <FontAwesomeIcon icon={faQrcode} />
                {qrConsuming ? 'Accesso in corso…' : 'Accedi con QR'}
              </button>
            </div>
          </div>
          {error ? (
            <div className="error-box">
              <div className="error-row">
                <p>{error}</p>
              </div>
            </div>
          ) : null}
          <div className="restore-option" onClick={() => setReset(true)}>
            Reimposta password
          </div>
        </div>
      </div>
      <QrScanner
        open={scannerOpen}
        onClose={() => setScannerOpen(false)}
        onScanned={onQrScanned}
      />
    </>
  )
}
async function login(
  username,
  password,
  setError,
  setLoading,
  setPassword,
  props,
) {
  let response = {}

  try {
    response = await fetch(`${baseUrl}/auth`, {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        password: password.trim(),
        email: username.trim(),
      }),
    })
    if (!response.ok) {
      let error = 'server error, retry!'
      try {
        error = await response.text()
      } catch {}
      setLoading(false)
      setError(error)
      setPassword('')
      setTimeout(() => {
        setError(false)
      }, 3000)
      return
    }
    let data = {}
    try {
      data = await response.json()
    } catch (e) {
      console.log(e.message)
    }
    if (data && data.token) {
      localStorage.setItem('cut-catering-token', data.token)
      props.setUser(jwt_decode(data.token))
    }
  } catch (e) {
    setLoading(false)
    setError("can't connect to server!")
    setTimeout(() => {
      setError(false)
    }, 3000)
    return
  }
}

export default Login
